import React from 'react';

import classes from './Backdrop.module.css';

const backdrop = (props) => {
  let classCss = [classes.Backdrop, classes.AnimateBackdrop, classes[props.styles]];
  if (props.noAnimation) {
    classCss = [classes.Backdrop, classes[props.styles]];
  }
  return (
    <div className={classCss.join(' ')} onClick={props.clicked} style={props.backdropStyle} id={props.id || 'BackDrop' + Math.random()} />
  );
};

export default backdrop;
